import { transformAndValidate } from 'class-transformer-validator';
import { action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Children, Component } from 'react';
import { lazyInject } from '../../IoC/container';
import { FormStore } from '../../stores/FormStore';
import bindCoreUI from '../provider/bindCoreUI';
import { UIProviderProps } from '../provider/UIProvider';

interface FormProps {
    validator;
    defaultData?;
    onSubmit;
    onReady?: (data: { store: FormStore }) => any;
    onChange?: (data: { name: string, value: string, store: FormStore }) => any;
    ui?: UIProviderProps;
}

@bindCoreUI
@observer export class Form extends Component<FormProps, any> {

    static childContextTypes = {
        form: PropTypes.object,
    };

    @lazyInject(FormStore) formStore: FormStore;

    done = () => this.formStore.isProcessing = false;
    fail = (e) => {
        this.formStore.errors = e;
        this.formStore.isProcessing = false;
    };

    constructor(props) {
        super(props);

        if (props.defaultData) {
            this.formStore.data = props.defaultData;
        }

        if (props.onReady) {
            props.onReady({ store: this.formStore });
        }
    }

    @action.bound async onSubmit() {
        const { onSubmit } = this.props;

        this.formStore.isProcessing = true;
        this.formStore.errors = [];

        try {
            await transformAndValidate(this.props.validator, toJS(this.formStore.data));

            onSubmit(this.formStore.data, this.done);
        } catch (e) {
            this.fail(e);
        }

        // onSubmit(this.formStore.data, () => this.formStore.isProcessing = false);
    }

    getChildContext() {
        const { validator } = this.props;

        return {
            form: {
                validator,
                store: this.formStore,
                onSubmit: this.onSubmit,
                onError: (errors) => {
                    this.formStore.errors = errors;
                },
                onChange: (name, value) => {
                    this.formStore.data[name] = value;

                    if (this.props.onChange) {
                        this.props.onChange({
                            store: this.formStore,
                            name,
                            value
                        });
                    }
                }
            }
        }
    }

    render() {
        const { ui } = this.props;

        const FormAdapter = ui.bindings.form.form;

        /*return <form onSubmit={e => { e.preventDefault(); this.onSubmit(); }}>
            { Children.toArray(this.props.children) }
        </form>;*/

        return <FormAdapter onSubmit={this.onSubmit}>
            { Children.toArray(this.props.children) }
        </FormAdapter>
    }

}
